import { Box, BoxProps } from "@chakra-ui/react";

import { ExitIcon, TickIcon } from "design_system/icons";
import { colors } from "src/colors";
import theme from "src/theme";

type Props = BoxProps & {
  isChecked: boolean;
  onChange: (isChecked: boolean) => void;
  disabled?: boolean;
};

const ToggleCheckbox = ({ isChecked = false, onChange, disabled, ...props }: Props) => {
  const CustomIcon = isChecked ? (
    <TickIcon size={32} color={colors.white.default} />
  ) : (
    <ExitIcon size={32} color={colors.white.default} />
  );

  const bgColor = disabled ? colors.grey[300] : isChecked ? colors.primary : colors.black[700];

  return (
    <Box
      w="40px"
      h="40px"
      borderRadius={theme.borderRadius.default}
      bg={bgColor}
      cursor={disabled ? "default" : "pointer"}
      onClick={() => !disabled && onChange(!isChecked)}
      {...props}
    >
      {CustomIcon}
    </Box>
  );
};

export default ToggleCheckbox;
